import React, { createContext, useEffect, useState } from 'react'
import { BrowserRouter as Router } from "react-router-dom";
import DoctorRoutes from "./routes/DoctorRoutes";
import { useSelector } from 'react-redux';
import { State } from './redux/store';
import MainPage from './pages/MainPage';
import AdminRoutes from './routes/AdminRoutes';
import FrontEndRoute from './routes/FrontEndRoute';
import { setPageDirection } from './functions/functions';

export interface pageDirInterface {
  pageDir: string, setPageDir: (pageDir: string) => void, 
}
export const pageDirInterfaceDefault: pageDirInterface = { 
  pageDir: "", setPageDir: () => {}, 
}

export const pageDirContext = createContext<pageDirInterface>(pageDirInterfaceDefault)

const App:React.FC = () => {
  const { userData } = useSelector((state: State) => state.login)
  const [pageDir, setPageDir] = useState<string>("")
  
  useEffect(() => {
    setPageDirection(setPageDir)
  }, [])

  if(userData._id) {
    return <Router>
      <MainPage />      
      <div className='w-full min-h-[90vh] mx-auto px-4 py-6'>
        {userData?.user && <AdminRoutes />}
        {userData?.doctor && <DoctorRoutes />}
      </div>
    </Router>
  } else {
    return <pageDirContext.Provider value={{ pageDir, setPageDir }}>
        <FrontEndRoute  />
      </pageDirContext.Provider>
  }

}

export default App
